module.exports = __webpack_public_path__ + "static/productivity-companion-421294ed8f1e454d7f2e96e3ddb7f208.gif";